export class ProcessedResult {
  origin: InputImage;
  result: ProcessedImage;
  message?: String

  constructor(options: {
    origin: InputImage,
    result?: ProcessedImage,
    message?: String,

  }) {
    this.origin = options.origin;
    this.result = options.result;
    this.message = options.message;
  }
}

export class ProcessedImage {
  data: InputImage;
  width: number
  height: number
  bytes: Uint8Array

  constructor(options: {
    data: InputImage,
    width?: number,
    height?: number,
    bytes?: Uint8Array
  }) {
    this.data = options.data;
    this.width = options.width;
    this.height = options.height;
    this.bytes = options.bytes;
  }
}

export class InputImage {
  /**
   * 图像像素点数据，一维数组，每四项表示一个像素点的rgba
   */
  data: Uint8ClampedArray;
  /**
   * 图像数据矩形的宽度
   */
  width: number
  /**
   * 图像数据矩形的高度
   */
  height: number

  constructor(options: {
    data: Uint8ClampedArray,
    width: number,
    height: number,
  }) {
    this.data = options.data;
    this.width = options.width;
    this.height = options.height;
  }
}

export enum ThresholdValueMode {
  sum,
  avg,
  red,
  green,
  blue,
  max,
  min,
}
